import React, { ButtonHTMLAttributes } from "react";
import classnames from "classnames";

import { Icon } from "../icon/Icon";

import "./CrossButton.scss";

interface CrossButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size: "small" | "medium" | "large";
  weight?: "regular" | "strong";
}

export const CrossButton = ({
  className,
  size,
  onClick,
  weight = "regular",
  ...attrs
}: CrossButtonProps) => {
  return (
    <button
      className={classnames("cross-button", `cross-button--${size}`, className)}
      type="button"
      onClick={onClick}
      {...attrs}
    >
      <Icon
        icon={classnames(
          "fa-times",
          weight === "strong" ? "fa-solid" : "fa-regular"
        )}
      />
    </button>
  );
};
